module.exports = __webpack_public_path__ + "img/img_text.5adaa2e7.png";